//src/styles/typography/lineHeights.js
/**
 * Line height configuration
 * Consistent line heights for better readability
 */

export const lineHeight = {
  // Tight line heights for headings
  none: 1,
  tight: 1.1,
  snug: 1.2,
  normal: 1.3,
  
  // Relaxed line heights for body text
  relaxed: 1.5,
  loose: 1.6,
  veryLoose: 1.8,
  
  // Specific use cases
  heading: 1.2,
  subheading: 1.3,
  body: 1.5,
  caption: 1.4,
  button: 1.2,
};

// Get line height by name with fallback
export const getLineHeight = (key, fallback = lineHeight.normal) => {
  return lineHeight[key] || fallback;
};

// Calculate line height based on font size (in pixels)
export const calculateLineHeight = (fontSizePx, multiplier = 1.5) => {
  return `${fontSizePx * multiplier}px`;
};

// Optional: Get all line heights as an array
export const getLineHeightOptions = () => {
  return Object.entries(lineHeight).map(([key, value]) => ({
    label: key.charAt(0).toUpperCase() + key.slice(1),
    value: key,
    lineHeight: value,
  }));
};

// No default export - only named exports